import { UserPermissions } from '@creditsights/api-ui-web';
import { Divider, Icon, ICONS } from '@creditsights/styleguide-web';
import { DisabledItem } from '@creditsights/styleguide-web/components/DataView/DataView.types';
import classNames from 'classnames/bind';
import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { FeedArticlePermissions } from '../../../../models';
import { getArticleLockType } from '../../../../utils/articleUtils';
import { getInitialConditionalAction, getRouteToCallback } from '../../../../utils/formattersUtils';
import styles from './LockedArticleLabel.module.scss';

const cx = classNames.bind(styles);

interface LockedArticleLabelProps {
  userPermissions?: UserPermissions;
  onItemClick?;
}

const LockedArticleLabel: DisabledItem<FeedArticlePermissions, LockedArticleLabelProps> = ({
  item,
  row,
  configuration,
  props,
}): ReactElement => {
  const routeToCallback = getRouteToCallback(configuration, item);
  const initialConditionalAction = getInitialConditionalAction(configuration, row, props, item);
  const lockType = getArticleLockType(item, props?.userPermissions!);

  return (
    <Link to={routeToCallback} className={cx('body')} onClick={initialConditionalAction}>
      <span className={cx('label')}>
        <Icon name={ICONS.LockOutline} />
        <Divider vertical className={cx('divider')} />
        <span data-testid="label-text">{lockType}</span>
      </span>
    </Link>
  );
};

export default LockedArticleLabel;
